
import {
  Component, PropSync, Prop, Ref, Watch, Mixins,
} from 'vue-property-decorator';
import { VForm } from '@/features/common/types';
import { UserItemType } from '@/features/users/types';
import { showErrorAlertDialog } from '@/features/common/helpers';
import { emailRules, requiredRules } from '@/features/common/helpers/validationRules';
import { AddUserDTO, editUser } from '@/features/users/services/users.services';
import focusMixin from '@/features/common/mixins/focusMixin';
import AccountSpecification from './AccountSpecification.vue';

@Component({
  components: {
    AccountSpecification,
  },
})
export default class EditUserModal extends Mixins(focusMixin) {
  @Ref('editUsersForm') form!: VForm;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) user!: UserItemType;

  private isLoading = false;

  private requiredRules = requiredRules;

  private emailRules = emailRules;

  private emailInput = '';

  private data: Omit<AddUserDTO, 'username'> = {
    firstName: '',
    lastName: '',
    disabled: false,
    permissions: {
      adminAccess: false,
      viewInvoices: false,
      sharedHistory: false,
    },
    askUserForDefaultAddress: false,
  }

  @Watch('user', { immediate: true })
  private setSelectedUser(user: UserItemType) {
    if (!user) return;

    const {
      firstName, lastName, disabled, permissions, username, askUserForDefaultAddress,
    } = user;

    this.data = {
      firstName,
      lastName,
      disabled: disabled || false,
      permissions: {
        adminAccess: permissions.adminAccess || false,
        viewInvoices: permissions.viewInvoices || false,
        sharedHistory: permissions.sharedHistory || false,
      },
      askUserForDefaultAddress: askUserForDefaultAddress || false,
    };

    this.emailInput = username;
  }

  private async submit(): Promise<void> {
    const isValid = this.form.validate();
    if (!isValid) return;

    this.isLoading = true;
    const response = await editUser(this.user.userId, {
      ...this.data,
    });
    this.isLoading = false;

    if (!response.successful) {
      const errorMessage = response.errorMessage
        || this.$t('alertDialog.somethingWentWrong') as string;
      showErrorAlertDialog(errorMessage);
      return;
    }

    this.$emit('update', response.user);
    this.syncedShow = false;
  }
}
